export const heroStats = [
  { label: '日均更新', value: '200+', unit: '条' },
  { label: '覆盖平台', value: '50+', unit: '个' },
  { label: '全天候', value: '7×24', unit: '小时' },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '全网娱乐热点第一时间同步，吃瓜永不掉队，51cgfun今日吃瓜快人一步',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度挖掘',
    desc: '专业编辑深扒事件来龙去脉，给你最全最真的51cg今日大瓜必吃大瓜视角',
  },
  {
    icon: 'ri-spy-line',
    title: '独家爆料',
    desc: '51cg独家信息渠道，朝阳群众一手消息源，大瓜速递直达你手中',
  },
  {
    icon: 'ri-global-line',
    title: '全网聚合',
    desc: '微博抖音小红书B站豆瓣多平台热点一站浏览，51cg吃瓜告别多App切换',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '趣味解读',
    desc: '轻松幽默的吃瓜方式陪你嗑完每个瓜，51cg.fun今日吃瓜就是好玩',
  },
];

export const topicIndex = [
  { title: '明星恋情', icon: 'ri-heart-line', desc: '娱乐圈情感动向第一手追踪', count: 1283, color: 'accent' },
  { title: '综艺热点', icon: 'ri-tv-line', desc: '热门综艺名场面全收录', count: 967, color: 'primary' },
  { title: '影视资讯', icon: 'ri-film-line', desc: '新剧上映票房口碑速递', count: 845, color: 'secondary' },
  { title: '网红八卦', icon: 'ri-user-smile-line', desc: '头部主播达人动态追踪', count: 723, color: 'accent' },
  { title: '潮流时尚', icon: 'ri-shirt-line', desc: '明星穿搭品牌活动全解析', count: 612, color: 'primary' },
  { title: '音乐现场', icon: 'ri-music-line', desc: '演唱会音乐节最新repo', count: 534, color: 'secondary' },
  { title: '体育花边', icon: 'ri-basketball-line', desc: '运动员场外趣闻合集', count: 456, color: 'accent' },
  { title: '社会热议', icon: 'ri-fire-line', desc: '全民关注的社会热点讨论', count: 389, color: 'primary' },
];

export const infoCards = [
  {
    tag: '独家爆料',
    tagColor: 'accent',
    title: '某顶流男星深夜密会神秘女子，疑似新恋情曝光',
    excerpt: '据51cg独家消息，某当红顶流男星近日被拍到与一位神秘女子深夜同返公寓，两人举止亲密...',
    time: '2小时前',
    views: '128.6万',
    comments: 8321,
    image: 'https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20background%20with%20soft%20golden%20and%20coral%20gradient%2C%20luxurious%20evening%20city%20vibe%2C%20elegant%20glamorous%20texture%2C%20editorial%20entertainment%20news%20aesthetic%2C%20cinematic%20mood%20lighting%2C%20warm%20amber%20and%20rose%20tones%2C%20professional%20magazine%20layout%20style&width=800&height=480&seq=card-01-51cg&orientation=landscape',
  },
  {
    tag: '综艺热点',
    tagColor: 'primary',
    title: '热门综艺录制现场突发状况，导演组紧急叫停',
    excerpt: '正在录制的某S+级综艺节目今日突发意外，某嘉宾情绪失控当场离场，引发全场哗然...',
    time: '4小时前',
    views: '96.3万',
    comments: 5402,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20lighting%20abstract%20background%20with%20warm%20spotlight%20effect%2C%20entertainment%20studio%20atmosphere%2C%20coral%20and%20amber%20gradient%20texture%2C%20performing%20arts%20visual%20style%2C%20theatrical%20mood%2C%20sophisticated%20elegant%20composition&width=800&height=480&seq=card-02-51cg&orientation=landscape',
  },
  {
    tag: '影视资讯',
    tagColor: 'secondary',
    title: '年度票房黑马诞生！这部小成本电影凭什么逆袭',
    excerpt: '一部投资仅千万的小成本影片在上映首周便斩获3亿票房，口碑持续发酵，成为今年最大黑马...',
    time: '6小时前',
    views: '75.8万',
    comments: 4198,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20abstract%20background%20with%20warm%20golden%20and%20rose%20gradient%2C%20movie%20premiere%20atmosphere%2C%20theater%20curtain%20texture%20visual%2C%20elegant%20dramatic%20lighting%2C%20Hollywood%20red%20carpet%20aesthetic%2C%20luxurious%20warm%20tones&width=800&height=480&seq=card-03-51cg&orientation=landscape',
  },
  {
    tag: '明星恋情',
    tagColor: 'accent',
    title: '某知名女星被曝与圈外男友低调领证',
    excerpt: '据可靠消息，某85后知名女演员已于上月悄悄与圈外男友完成婚姻登记，双方家长均已知情...',
    time: '8小时前',
    views: '112.4万',
    comments: 7823,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20abstract%20background%20with%20soft%20rose%20gold%20and%20cream%20gradient%2C%20wedding%20romance%20atmosphere%2C%20elegant%20floral%20texture%20visual%2C%20delicate%20warm%20lighting%2C%20luxury%20editorial%20style%2C%20sophisticated%20refined%20composition&width=800&height=480&seq=card-04-51cg&orientation=landscape',
  },
  {
    tag: '网红八卦',
    tagColor: 'primary',
    title: '千万粉主播直播间口误，泄露行业重大内幕',
    excerpt: '某拥有千万粉丝的头部主播在近日直播中意外说漏嘴，透露了直播带货行业不为人知的灰色操作...',
    time: '10小时前',
    views: '89.7万',
    comments: 6234,
    image: 'https://readdy.ai/api/search-image?query=Digital%20media%20abstract%20background%20with%20warm%20orange%20and%20coral%20gradient%2C%20streaming%20studio%20atmosphere%2C%20modern%20technology%20texture%20visual%2C%20vibrant%20engaging%20lighting%2C%20social%20media%20aesthetic%2C%20dynamic%20contemporary%20composition&width=800&height=480&seq=card-05-51cg&orientation=landscape',
  },
  {
    tag: '音乐现场',
    tagColor: 'secondary',
    title: '某天王级歌手演唱会突发设备故障，即兴清唱封神',
    excerpt: '在一场万人演唱会上，音响设备中途出现故障，歌手临危不乱即兴清唱，被歌迷称为神级现场...',
    time: '12小时前',
    views: '67.2万',
    comments: 3876,
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20abstract%20background%20with%20warm%20golden%20spotlight%20and%20amber%20gradient%2C%20live%20music%20atmosphere%2C%20dramatic%20lighting%20effect%20texture%2C%20rock%20concert%20energy%20visual%2C%20epic%20performance%20aesthetic%2C%20powerful%20engaging%20composition&width=800&height=480&seq=card-06-51cg&orientation=landscape',
  },
  {
    tag: '时尚潮流',
    tagColor: 'accent',
    title: '国际时装周中国明星造型大盘点，谁的穿搭最出圈',
    excerpt: '本季国际时装周迎来众多中国面孔，从高定礼服到街头潮牌，明星们的红毯与街拍造型引发热议...',
    time: '14小时前',
    views: '53.9万',
    comments: 2945,
    image: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20abstract%20background%20with%20warm%20coral%20and%20rose%20gold%20gradient%2C%20luxury%20fashion%20show%20atmosphere%2C%20elegant%20fabric%20texture%20visual%2C%20glamorous%20editorial%20lighting%2C%20high%20fashion%20aesthetic%2C%20sophisticated%20contemporary%20composition&width=800&height=480&seq=card-07-51cg&orientation=landscape',
  },
];

export const faqItems = [
  {
    q: '51cg是什么？跟51cgfun今日吃瓜有什么关系？',
    a: '51cg是国内领先的娱乐资讯聚合平台，专注为吃瓜群众提供最新最全的娱乐爆料和大瓜速递。51cgfun今日吃瓜是51cg的核心内容品牌，两者同属一个平台，致力于用轻松有趣的方式呈现每日最新吃瓜内容，让你不错过任何一个值得关注的热点事件。无论你搜索51cg、51cgfun、还是51cg.fun，都能找到我们。',
  },
  {
    q: '51cg的内容来源可靠吗？会不会有假瓜？',
    a: '51cg建立了严格的内容审核机制，所有资讯均来自公开可查的社交平台、权威媒体报道及官方渠道信息。我们的编辑团队会对每条信息进行交叉验证，标注信息来源和可信度等级。对于未经证实的传闻，我们会明确标注"待核实"，让51cg吃瓜群众吃得明明白白。',
  },
  {
    q: '如何第一时间获取51cg最新吃瓜动态？',
    a: '你可以通过多种方式关注51cg：访问51cg.fun官网查看实时更新的热点榜单；下载51cg移动客户端开启推送通知，确保大瓜第一时间送达；也可以关注51cg在各大社交平台的官方账号。我们承诺51cg今日大瓜必吃大瓜永不断更，7×24小时全天候更新。',
  },
  {
    q: '51cg和朝阳群众有什么关系？',
    a: '"朝阳群众"是网络流行语中代指爆料人的称呼。51cg作为吃瓜聚合平台，与广大热心爆料网友保持着良好的互动关系。我们的51cg吃瓜速递栏目专门收集来自各方的真实爆料，经过核实后发布。如果你也有料要爆，欢迎通过投稿通道联系我们！',
  },
];

export const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子', heat: '9800万', trend: 'up', tag: '爆' },
  { rank: 2, title: '热门综艺录制现场突发意外状况', heat: '8750万', trend: 'up', tag: '热' },
  { rank: 3, title: '某85后女星被曝与圈外男友领证', heat: '7620万', trend: 'up', tag: '热' },
  { rank: 4, title: '年度票房黑马小成本电影逆袭', heat: '6890万', trend: 'up', tag: '新' },
  { rank: 5, title: '千万粉主播直播口误泄露行业内幕', heat: '6120万', trend: 'up', tag: '热' },
  { rank: 6, title: '天王级歌手演唱会即兴清唱封神', heat: '5480万', trend: 'up', tag: '荐' },
];

export const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20portrait%20style%20abstract%20profile%20picture%20with%20soft%20coral%20and%20cream%20gradient%2C%20simple%20elegant%20avatar%20design%2C%20clean%20minimal%20aesthetic&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '32分钟前',
    content: '这个瓜我吃定了！51cg果然从不让人失望，每次都能蹲到第一手消息。这个时间点曝出来，感觉后面还有更大的料等着我们呢！坐等51cg继续深挖！',
    likes: 2834,
    badge: '铁杆瓜友',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20profile%20circle%20with%20soft%20amber%20and%20gold%20gradient%2C%20simple%20elegant%20avatar%20style%2C%20clean%20modern%20aesthetic&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '今日份快乐源泉',
    time: '1小时前',
    content: '每天上班摸鱼就靠51cg续命了哈哈！51cgfun今日吃瓜的更新速度真的绝了，早上刷到的瓜下午就有后续跟进，编辑们是住在网上了吗？respect！',
    likes: 1829,
    badge: '资深吃瓜人',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20profile%20circle%20with%20soft%20rose%20and%20peach%20gradient%2C%20simple%20elegant%20avatar%20design%2C%20clean%20modern%20minimal%20aesthetic&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '理中客路人甲',
    time: '2小时前',
    content: '理性吃瓜，不站队，等实锤。不过51cg的深度挖掘确实做得好，每次都能把事件前因后果理得明明白白，比那些只会跟风的自媒体强太多了。51cg吃瓜，品质有保障。',
    likes: 1156,
    badge: '理性瓜友',
  },
];

export const topicTags = [
  { name: '明星恋情', count: '1283条', icon: 'ri-heart-pulse-line' },
  { name: '综艺名场面', count: '967条', icon: 'ri-emotion-line' },
  { name: '影视票房', count: '845条', icon: 'ri-ticket-line' },
  { name: '网红翻车', count: '723条', icon: 'ri-alert-line' },
  { name: '音乐现场', count: '612条', icon: 'ri-mic-line' },
  { name: '时尚红毯', count: '534条', icon: 'ri-vip-crown-line' },
  { name: '体育花边', count: '456条', icon: 'ri-medal-line' },
  { name: '社会热议', count: '389条', icon: 'ri-chat-poll-line' },
  { name: 'CP发糖', count: '341条', icon: 'ri-hearts-line' },
  { name: '翻拍争议', count: '298条', icon: 'ri-contrast-line' },
];

export const contactInfo = {
  title: '爆料投稿 / 商务合作',
  desc: '你有独家爆料？想与51cg合作？欢迎通过以下方式联系我们。51cg吃瓜速递期待每一位朝阳群众的真实声音，你的线索可能就是下一个全民大瓜！',
  email: 'tips@51cg.fun',
  wechat: '51cg_official',
  tips: '投稿请注明信息来源，我们将严格保护爆料人隐私。商务合作请备注公司名称与合作意向。',
};

export const carouselItems = [
  {
    title: '2024年度十大必吃大瓜回顾',
    desc: '从塌房到恋情曝光，这一年娱乐圈的瓜一个比一个大',
    image: 'https://readdy.ai/api/search-image?query=Warm%20dramatic%20abstract%20collage%20background%20with%20golden%20coral%20and%20deep%20burgundy%20gradient%2C%20luxurious%20award%20ceremony%20atmosphere%2C%20spotlight%20effect%20texture%2C%20elegant%20editorial%20magazine%20cover%20style%2C%20sophisticated%20visual%20design&width=1200&height=640&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
    badge: 'HOT',
  },
  {
    title: '某顶流男星塌房全记录时间线',
    desc: '从爆料到实锤，完整梳理事件始末与各方回应',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20abstract%20background%20with%20warm%20amber%20and%20deep%20mahogany%20gradient%2C%20investigative%20journalism%20atmosphere%2C%20serious%20mood%2C%20professional%20newsroom%20aesthetic&width=1200&height=640&seq=carousel-02&orientation=landscape',
    tag: '深度专题',
    badge: '重磅',
  },
  {
    title: '综艺名场面：那些让全网笑疯的瞬间',
    desc: '从选秀到脱口秀，盘点本季综艺的高光与翻车时刻',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20entertainment%20abstract%20background%20with%20warm%20coral%20and%20gold%20gradient%2C%20variety%20show%20stage%20atmosphere%2C%20colorful%20dynamic%20lighting%2C%20fun%20energetic%20mood%2C%20modern%20TV%20production%20aesthetic&width=1200&height=640&seq=carousel-03&orientation=landscape',
    tag: '综艺精选',
    badge: '热门',
  },
  {
    title: '娱乐圈CP大乱炖：谁和谁才是真的',
    desc: '盘点那些被拍到同框后引发全网热议的明星CP',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20warm%20abstract%20background%20with%20rose%20gold%20and%20soft%20coral%20gradient%2C%20dating%20rumor%20atmosphere%2C%20elegant%20romantic%20lighting%2C%20sweet%20dreamy%20visual%20style&width=1200&height=640&seq=carousel-04&orientation=landscape',
    tag: 'CP特辑',
    badge: '甜蜜',
  },
  {
    title: '直播带货行业：光环背后的隐秘角落',
    desc: '深入揭秘直播电商行业不为人知的运营内幕与潜规则',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20abstract%20background%20with%20warm%20orange%20and%20amber%20gradient%2C%20ecommerce%20livestreaming%20atmosphere%2C%20technology%20studio%20visual%2C%20professional%20business%20aesthetic&width=1200&height=640&seq=carousel-05&orientation=landscape',
    tag: '行业揭秘',
    badge: '独家',
  },
  {
    title: '00后新星崛起：新一代顶流的诞生',
    desc: '从练习生到爆红，盘点2024年最值得关注的新生代艺人',
    image: 'https://readdy.ai/api/search-image?query=Youthful%20vibrant%20abstract%20background%20with%20warm%20peach%20and%20gold%20gradient%2C%20rising%20star%20atmosphere%2C%20fresh%20energetic%20lighting%2C%20modern%20young%20celebrity%20style&width=1200&height=640&seq=carousel-06&orientation=landscape',
    tag: '新星特写',
    badge: '关注',
  },
];

export const updates = [
  { time: '刚刚', content: '某知名导演新片选角名单疑似流出，多位一线明星在列', tag: '影视资讯' },
  { time: '18分钟前', content: '某女星在社交平台发长文回应近期争议，态度强硬', tag: '明星动态' },
  { time: '35分钟前', content: '某综艺节目录制现场路透照曝光，嘉宾阵容引热议', tag: '综艺热点' },
  { time: '52分钟前', content: '某品牌官宣新代言人，粉丝评论区已炸锅', tag: '时尚快讯' },
  { time: '1小时前', content: '某歌手新专辑预售破纪录，实体唱片市场回暖信号', tag: '音乐动态' },
  { time: '2小时前', content: '某网红被扒出早年黑历史，本人连夜删博引猜测', tag: '网红八卦' },
  { time: '3小时前', content: '某热播剧编剧回应大结局争议，称第二季已在筹备', tag: '影视资讯' },
  { time: '4小时前', content: '某国际品牌时装秀中国区直播观看人数创新高', tag: '时尚快讯' },
];

export const aboutInfo = {
  title: '关于51cg',
  paragraphs: [
    '51cg创立于对娱乐资讯真实性与时效性的极致追求。我们的团队由资深娱乐记者、社交媒体分析师和内容策划专家组成，致力于在信息爆炸的时代，为每一位吃瓜群众提供值得信赖的热点追踪服务。',
    '我们深知，在人人都是自媒体的今天，真假难辨的信息充斥着每一个角落。51cg坚持"有据可查、有源可溯"的内容准则，每一条51cg今日大瓜必吃大瓜都经过多方交叉验证，确保你吃到的每一个瓜都是保质保量的真瓜。',
    '从51cgfun今日吃瓜到51cg.fun今日吃瓜，我们不断完善内容矩阵，覆盖明星恋情、综艺热点、影视资讯、网红八卦、潮流时尚等多个领域。无论你是重度吃瓜爱好者，还是偶尔关心娱乐动态的路人，51cg都是你最可靠的吃瓜伙伴。',
    '未来，51cg将继续深耕娱乐资讯领域，用技术驱动内容分发，让51cg最新吃瓜永远快人一步。吃真瓜，上51cg。',
  ],
};

export const appInfo = {
  title: '随时随地，吃瓜不停',
  desc: '下载51cg客户端，开启推送通知，大瓜第一时间送达。支持iOS与Android，更有独家内容仅在App端可见。',
  features: ['实时推送', '独家内容', '离线阅读', '夜间模式', '评论互动'],
};

export const mediaItems = [
  {
    title: '2024娱乐圈大事件混剪',
    desc: '三分钟回顾今年最令人瞠目结舌的吃瓜名场面',
    duration: '03:28',
    views: '256.8万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20video%20thumbnail%20background%20with%20warm%20golden%20and%20coral%20gradient%2C%20play%20button%20visual%2C%20film%20reel%20texture%2C%20dramatic%20lighting%20effect%2C%20entertainment%20highlight%20reel%20aesthetic&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '明星红毯造型全解析',
    desc: '专业造型师点评本季红毯最惊艳与最翻车的穿搭',
    duration: '05:15',
    views: '189.3万',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20red%20carpet%20abstract%20background%20with%20warm%20rose%20and%20champagne%20gradient%2C%20glamorous%20camera%20flash%20effect%2C%20luxurious%20celebrity%20style%20visual%2C%20elegant%20editorial%20aesthetic&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '吃瓜课堂：如何辨别真假爆料',
    desc: '资深娱记教你三招识破假瓜，从此只吃真瓜',
    duration: '08:42',
    views: '143.6万',
    image: 'https://readdy.ai/api/search-image?query=Educational%20abstract%20background%20with%20warm%20amber%20and%20tan%20gradient%2C%20classroom%20newsroom%20atmosphere%2C%20professional%20investigative%20style%2C%20clean%20modern%20teaching%20visual%20aesthetic&width=800&height=500&seq=media-03&orientation=landscape',
  },
];